import { render, staticRenderFns } from "./DataRuleList.vue?vue&type=template&id=67c16af2&scoped=true&"
import script from "./DataRuleList.vue?vue&type=script&lang=js&"
export * from "./DataRuleList.vue?vue&type=script&lang=js&"
import style0 from "./DataRuleList.vue?vue&type=style&index=0&id=67c16af2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c16af2",
  null
  
)

export default component.exports